/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { modifier } from "ember-modifier";
import type JournalEventModel from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import { getJesOfClass } from "parog-web/utils/journal-events";
import { sortBy } from "parog-web/utils/sort";
import type JesHistoryTableColumnComponent from "./column";

import styles from "./index.module.css";

interface Signature {
  Args: {
    patient: Patient;
  };
}

export default class JesHistoryTableComponent extends Component<Signature> {
  styles = styles;

  get patient() {
    return this.args.patient;
  }

  @tracked columns: JesHistoryTableColumnComponent[] = [];
  #columns: JesHistoryTableColumnComponent[] = [];
  @tracked dropdownMenu;

  get jesByColumn() {
    const res: [JesHistoryTableColumnComponent, JournalEventModel[]][] =
      this.columns.map(column => {
        try {
          return [
            column,
            this.patient
              .get(column.patientRelationName)
              // This filter should probably be done elsewhere, maybe on the patient as we have `journalEvents` & `activeJournalEvents` or we can consider that all fetched JE are not archived ?
              .filter(je => !je.isArchived)
              .sort(sortBy("occurredAt", "desc"))
          ];
        } catch {
          return [
            column,
            getJesOfClass(this.patient.activeJournalEvents, column.jeClass)
          ];
        }
      });

    return new Map(res);
  }

  get dates() {
    const timestamps = this.columns.flatMap(column => {
      const jes = this.jesByColumn.get(column) as JournalEventModel[];
      return jes.map(je => +je.occurredOn);
    });

    // map timestamps to unique, sorted
    return [...new Set(timestamps)]
      .sort()
      .reverse()
      .map(ts => new Date(ts));
  }

  @action
  addColumn(column) {
    this.#columns.push(column);
  }

  setupColumns = modifier(this._setupColumns);

  @action
  _setupColumns() {
    this.columns = this.#columns;
  }

  setDropdownMenu = modifier(this._setDropdownMenu);

  @action
  _setDropdownMenu(el) {
    this.dropdownMenu = el;
  }
}
